import URL from './url'
import HTTP from './http-common'

const optionsInterestList = () => HTTP({
  url: URL.optionsInterestList, method: 'GET',
})
  .then(resp => resp.data.tags.map(tag => tag.name))
  .catch((err) => {
    console.log(err)
  })

const optionsTextileList = () => HTTP({
  url: URL.optionsTextileList, method: 'GET',
})
  .then(resp => resp.data.tags.map(tag => tag.name))
  .catch((err) => {
    console.log(err)
  })

const optionsCountry = () => HTTP({
  url: URL.optionsCountry, method: 'GET',
})
  .then(resp => resp.data.tags.map(tag => tag.name))
  .catch((err) => {
    console.log(err)
  })

const optionsLocationFactory = () => HTTP({
  url: URL.locationFactory, method: 'GET',
})
  .then(resp => resp.data.tags)
  .catch((err) => {
    console.log(err)
  })

const optionsLocationCustomer = () => HTTP({
  url: URL.locationCustomer, method: 'GET',
})
  .then(resp => resp.data.tags)
  .catch((err) => {
    console.log(err)
  })

export { optionsInterestList, optionsTextileList, optionsCountry, optionsLocationFactory, optionsLocationCustomer }
